import React from 'react';
import ButtonUnstyled from 'components/ButtonUnstyled';
import './ListItem.css';

export default ({image, children, onClick}) => {
  return (
    <ButtonUnstyled className="ListItem" onClick={onClick}>
      {image ? <div className="ListItem__Image">{image}</div> : null}
      <div className="ListItem__Text">{children}</div>
    </ButtonUnstyled>
  );
};
